import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { RouteNames } from '../constants/route-names';
import { PartnerPortalContextService } from '../services/partner-portal-context.service';

/**
 * Keeps a partner on the setup wizard until their account and payout setup are done. Reads the
 * cached per-sign-in answer from `PartnerPortalContextService`, so it costs no request per
 * navigation; non-partners and failed reads pass straight through.
 */
export const partnerOnboardingGuard: CanActivateFn = () => {
  const router = inject(Router);
  const portalContext = inject(PartnerPortalContextService);

  return portalContext.onboardingComplete$.pipe(
    filter((complete): complete is boolean => complete !== null),
    take(1),
    map(
      (complete) =>
        complete || router.createUrlTree(['/', RouteNames.PARTNER_PORTAL_ROUTE, RouteNames.PARTNER_PORTAL_SETUP_SEGMENT])
    )
  );
};
